module.exports = __webpack_public_path__ + "media/images/banner/coupons/coupon02-th-0f96602547b9bbff60908375052c1c8d.png";